// Global UI sound effects: scroll_over.mp3 on hover, click.mp3 on click.
// Uses event delegation on `document` so dynamically-added elements
// (shop items, lobby host rows, modals, etc.) are covered automatically
// without needing per-element listeners.
//
// Behavior guarantees enforced together with playSound() in assets.js:
//   - A sound that's still playing won't be restarted (no cancel).
//   - Spam-hover or spam-click won't queue or stack — extra triggers are
//     just dropped while the sound is still in progress.

import { playSound } from '../assets.js';

// Anything that should react to hover + click. Tweak this if you add
// new clickable surfaces.
const HOVER_TARGET_SELECTOR = [
    'button',
    '.action-btn',
    '.inventory-item',
    '.snordeluxe-item',
    '.snordeluxe-select-card',
    '.lobby-host-row',
    '.lobby-join-btn',
    '.evolve-icon',
    '.daily-reward-corner',
    '.arsenal-close',
    '.close-button'
].join(', ');

let lastHoverTarget = null;

function findHoverTarget(node) {
    if (!node || !node.closest) return null;
    return node.closest(HOVER_TARGET_SELECTOR);
}

function onPointerOver(e) {
    const target = findHoverTarget(e.target);
    if (!target) return;
    if (target === lastHoverTarget) return; // already hovering this one
    lastHoverTarget = target;
    playSound('scroll_over');
}

function onPointerOut(e) {
    // Drop the hover memo when the pointer truly leaves the target
    // (relatedTarget is outside the same hover element).
    if (!lastHoverTarget) return;
    const goingTo = findHoverTarget(e.relatedTarget);
    if (goingTo !== lastHoverTarget) {
        lastHoverTarget = null;
    }
}

function onClick(e) {
    const target = findHoverTarget(e.target);
    if (!target) return;
    playSound('click');
}

let installed = false;
export function installUiSounds() {
    if (installed) return;
    installed = true;
    document.addEventListener('pointerover', onPointerOver, true);
    document.addEventListener('pointerout', onPointerOut, true);
    document.addEventListener('click', onClick, true);
}
